import template from './index.jst';
import './index.styl';
import { ContactUsCoreView } from '../../../../../core/views';

export default class TippingContactUsView extends ContactUsCoreView {
	get template() {
		return template;
	}

	get className() {
		return "tipping-help-page contact-us-page";
	}

	get file_name() {
		return 'tipping_nrl';
	}

	get var_name() {
		return 'tipping_contact_us';
	}

}